var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
        title: _vm.config.title,
        visible: _vm.dialogVisible,
        width: "540px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "mt15",
          attrs: {
            "label-width": _vm.labelWidth + "px",
            model: _vm.rules,
            rules: _vm.rule,
          },
        },
        [
          _vm.config.type == 1 && _vm.config.formType
            ? _c(
                "el-form-item",
                { attrs: { prop: "cid" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("选择合同： "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择合同", size: "small" },
                      model: {
                        value: _vm.rules.cid,
                        callback: function ($$v) {
                          _vm.$set(_vm.rules, "cid", $$v)
                        },
                        expression: "rules.cid",
                      },
                    },
                    _vm._l(_vm.contractData, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.title, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "radio" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(
                  _vm._s(_vm.config.type !== 3 ? "业务类型" : "提醒类型") +
                    "： "
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.radioChange },
                  model: {
                    value: _vm.rules.radio,
                    callback: function ($$v) {
                      _vm.$set(_vm.rules, "radio", $$v)
                    },
                    expression: "rules.radio",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(
                      " " + _vm._s(_vm.config.type !== 3 ? "回款" : "回款提醒")
                    ),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(
                      " " + _vm._s(_vm.config.type !== 3 ? "续费" : "续费提醒")
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: "amount" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(_vm._s(_vm.title01) + "："),
              ]),
              _vm._v(" "),
              _c("el-input-number", {
                attrs: {
                  controls: false,
                  min: 0,
                  placeholder: _vm.placeholder01,
                  precision: 2,
                  size: "small",
                },
                model: {
                  value: _vm.rules.amount,
                  callback: function ($$v) {
                    _vm.$set(_vm.rules, "amount", $$v)
                  },
                  expression: "rules.amount",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.rules.radio == 2 || _vm.config.type == 3
            ? _c(
                "el-form-item",
                { attrs: { prop: _vm.mandatory } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v(_vm._s(_vm.title02) + "："),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    attrs: {
                      "default-time": _vm.config.type == 3 ? "09:00:00" : "",
                      placeholder: _vm.placeholder02,
                      type: _vm.config.type == 3 ? "datetime" : "date",
                      size: "small",
                    },
                    model: {
                      value: _vm.rules.endDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.rules, "endDate", $$v)
                      },
                      expression: "rules.endDate",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.config.type !== 3
            ? _c(
                "el-form-item",
                { attrs: { prop: "type_id" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("支付方式："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择支付方式", size: "small" },
                      model: {
                        value: _vm.rules.type_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.rules, "type_id", $$v)
                        },
                        expression: "rules.type_id",
                      },
                    },
                    _vm._l(_vm.paymentOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.config.type !== 3
            ? _c(
                "el-form-item",
                { attrs: { prop: "dateTime" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("付款时间："),
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    attrs: {
                      "picker-options": _vm.pickerOptions,
                      placeholder: _vm.placeholder02,
                      "picker-options": "expireTimeOption",
                      size: "small",
                      type: "datetime",
                    },
                    model: {
                      value: _vm.rules.dateTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.rules, "dateTime", $$v)
                      },
                      expression: "rules.dateTime",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.config.type !== 3
            ? _c("el-form-item", [
                _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                  _vm._v("付款凭证："),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "avatar" },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "mr10 upload-demo",
                        attrs: {
                          headers: _vm.myHeaders,
                          "http-request": _vm.uploadServerLog,
                          "show-file-list": false,
                          action: "##",
                        },
                      },
                      [
                        _vm.imageUrl
                          ? _c("img", {
                              staticClass: "img",
                              attrs: { src: _vm.imageUrl },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "clew" }, [
                      _vm._v("支持jpg、jpeg、png "),
                      _c("br"),
                      _vm._v("建议734*1034 "),
                      _c("br"),
                      _vm._v("大小不超过2M"),
                    ]),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { prop: _vm.config.type == 3 ? "remarks" : "" } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(
                  _vm._s(_vm.config.type !== 3 ? "备注" : "提醒内容") + "："
                ),
              ]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  maxlength: "255",
                  "show-word-limit": "",
                  type: "textarea",
                },
                model: {
                  value: _vm.rules.remarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.rules, "remarks", $$v)
                  },
                  expression: "rules.remarks",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("public.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, size: "small", type: "primary" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("public.ok")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }